import { Link, LinkProps } from 'react-router-dom'

import { getI18nPath } from './helpers'

const I18nLink = (props: LinkProps) => {
  const to = getI18nPath(props.to)

  return <Link {...props} to={to} />
}

export default I18nLink
